import React from 'react';

import {
  t,
} from '../../helpers';

import './Header.css';

const Header = () => (
  <header id="header" className="masthead intro">
    <div className="intro-body">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <h1 className="brand-heading">{t('header.title')}</h1>
            <p className="intro-text">{t('header.text')}</p>
            <a href="#about" className="btn btn-circle js-scroll-trigger">
              <i className="fa fa-angle-double-down animated" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js